export default class ItemEachPage {
  constructor() {
    this.bindQuickSubmit()
  }

  buildUrlWithEachPage(eachPage) {
    const url = new URL(window.location.href)
    url.searchParams.set('items_each_page', eachPage)
    url.searchParams.delete('page')
    return url
  }

  syncEachPageState(eachPage) {
    $("input[name='items_each_page']").val(eachPage)
    $('.select-items-each-page, .show-number-of-page-js').each((_, element) => {
      element.textContent = eachPage
    })

    $('.filter-content-number-record .option, .filter-content-number-record-task .option, #itemOfPage .option').removeClass('slted')
    $(`.filter-content-number-record .option, .filter-content-number-record-task .option, #itemOfPage .option`).filter((_, element) => {
      return $(element).text().trim() === `${eachPage}`
    }).addClass('slted')
  }

  selectEachPage(element, eachPage) {
    const container = element.closest('.filter-content')
    this.syncEachPageState(eachPage)

    if (!container || !container.querySelector('.quick-submit')) {
      this.changeEachPage(eachPage)
      return
    }

    container.dataset.itemsEachPage = eachPage
    $(container).find('.option').removeClass('slted')
    $(element).addClass('slted')
  }

  bindQuickSubmit() {
    document.addEventListener('click', (event) => {
      const submitButton = event.target.closest(
        '.filter-content-number-record .quick-submit, .filter-content-number-record-task .quick-submit'
      )
      if (!submitButton) return

      const container = submitButton.closest('.filter-content')
      const eachPage =
        container?.dataset.itemsEachPage ||
        container?.querySelector('.option.slted')?.textContent?.trim() ||
        container?.closest('form')?.querySelector("input[name='items_each_page']")?.value ||
        $("input[name='items_each_page']").first().val()

      if (!eachPage) return

      event.preventDefault()
      event.stopPropagation()
      this.syncEachPageState(eachPage)
      this.tmGoWithEachPage(eachPage)
    }, true)
  }

  // FIX 20260806Q-toppanel TOPパネルが開いている時は、ページごと移動せずパネル内だけ読み直す。
  //   location.assign で移動するとパネルが閉じてしまうため。
  //   パネルが無い画面（ファイル一覧・タスク一覧等）は従来どおり移動する。
  tmGoWithEachPage(eachPage) {
    const url = this.buildUrlWithEachPage(eachPage).toString()
    if (document.getElementById('tmTopPanel') && window.tmPanelReload) {
      if (window.tmPanelReload(url)) return
    }
    window.location.assign(url)
  }
  change(ele) {
    const eachPage = $(ele).val()
    this.syncEachPageState(eachPage)
    this.tmGoWithEachPage(eachPage)
  }

  changeEachPage(eachPage) {
    this.syncEachPageState(eachPage)
    this.tmGoWithEachPage(eachPage)
  }
}
